'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PresetAmountSelectorsComponent = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _buttons = require('@sitebase/ui-kit/es/buttons');

var _constants = require('../../constants');

var _PresetAmountSelector = require('../../components/PresetAmountSelector');

var _PresetAmountSelector2 = _interopRequireDefault(_PresetAmountSelector);

var _quickDepositLogic = require('@wh/quick-deposit-logic');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PresetAmountSelectorsComponent = exports.PresetAmountSelectorsComponent = function PresetAmountSelectorsComponent(_ref) {
  var amountValues = _ref.amountValues,
      change = _ref.change,
      currencyCode = _ref.currencyCode,
      currentAmountValue = _ref.currentAmountValue,
      formElementIndex = _ref.formElementIndex,
      maxDeposit = _ref.maxDeposit,
      hasPlayerSetAmount = _ref.hasPlayerSetAmount,
      updatePlayerSetAmount = _ref.updatePlayerSetAmount;

  var updateAmount = function updateAmount(amount) {
    return function (event) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }

      setTimeout(function () {
        change(_constants.QD_RF_FORM_NAME, _constants.QD_RF_FIELD_AMOUNT, (0, _quickDepositLogic.formatNumber)(amount, 2));
      }, 0);
    };
  };

  var maxFiveAmountValues = (amountValues || []).slice(0, 5);
  return _react2.default.createElement(
    _buttons.ButtonGroup,
    { className: 'qd-amount-buttons', columns: 5, outfit: 'blue-30 normal quinary' },
    maxFiveAmountValues.map(function (amountValue, index) {
      return _react2.default.createElement(_PresetAmountSelector2.default, {
        amountValue: amountValue,
        currentAmountValue: currentAmountValue,
        currencyCode: currencyCode,
        key: index,
        onClick: updateAmount(amountValue),
        tabIndex: formElementIndex,
        maxDeposit: maxDeposit,
        hasPlayerSetAmount: hasPlayerSetAmount,
        updatePlayerSetAmount: updatePlayerSetAmount
      });
    })
  );
};